export class NoRecordsFound {
    status: boolean;
    statusCode: number;
    intlCode: number
    errorType: string;
    statusInfo: string;
    internalMessage: string;
    constructor() {
        this.status = false;
        this.statusCode = 90001;
        this.errorType = 'Information Message';
        this.intlCode = 99998;
        this.statusInfo = 'No Records Found';
        this.internalMessage = 'No Records Found';
    }
}
